<div class="page">
    <app-loading-spinner *ngIf="loading">
    </app-loading-spinner>
    <div class="content" *ngIf="!loading">
        <app-activity #operation
                      [activity]="activity"
                      [showDetails]="true"
                      [showActions]="!canActivityBeStarted()"
                      (timerStart)="onTimerStart()"
                      (revisionInfoClick)="onRevisionInfoClick()">
        </app-activity>
        <div class="activity-content">
            <div class="groupings-container">
                <div class="groupings">
                    <div class="info-message" *ngIf="canActivityBeStarted()"><i
                        class="material-icons">warning</i> {{ 'service.tickets.details.activityDetails.needToScanTools' | translate }}
                    </div>
                    <ng-container *ngFor="let group of groupings"
                                  [ngTemplateOutlet]="grouping"
                                  [ngTemplateOutletContext]="{group: group}">
                    </ng-container>
                </div>
                <div class="groupings-footer">
                    <p class="selected-tasks">
                        {{ selectedTasks.length }} {{ 'service.tickets.details.activityDetails.tasksSelected' | translate }}
                    </p>
                    <div class="actions" *ngIf="activity && activity.status === 'InProgress' && !readonly">
                        <app-button type="success" class="btn btn-success done" (click)="finishTask('done')">
                            {{ 'service.tickets.details.activityDetails.buttons.done' | translate }}
                        </app-button>
                        <app-button type="danger" class="not-done" (click)="finishTask('notDone')">
                            {{ 'service.tickets.details.activityDetails.buttons.notDone' | translate }}
                        </app-button>
                    </div>
                </div>
            </div>

            <div class="divider-wrapper">
                <div class="divider"></div>
            </div>

            <div class="task-details" *ngIf="selectedTask || loadingTask">
                <div class="loader" *ngIf="loadingTask">
                    <app-loading-spinner></app-loading-spinner>
                </div>
                <app-ticket-task-details *ngIf="selectedTask && !loadingTask"
                                         [infoMessage]="computeInfoMessage(selectedTask)"
                                         [task]="selectedTask"
                                         [toolCount]="getSelectedTaskToolCount()"
                                         (downloadDocuments)="handleDownloadDocuments($event)"
                                         (previewDocuments)="handlePreviewDocuments($event)"
                                         (onUpdateTicketTask)="updateTicketTask($event)">
                </app-ticket-task-details>
            </div>

        </div>
    </div>
</div>

<ng-template #grouping let-group="group">
    <div class="group">
        <div class="header row">
            <div class="header-info">
                <p>{{ getGroupName(group) }}</p>
                <app-tooltip type="info"
                             [displayType]="'tools'"
                             [record]="getToolNames(group)">
                </app-tooltip>
                <app-tooltip *ngIf="computeCanStart(group)"
                             type="warning"
                             [record]="'service.tickets.details.activityDetails.canStartTooltip' | translate">
                </app-tooltip>
            </div>
            <div class="header-actions">
                <app-button type="primary" *ngIf="isReturnedPossible()"
                            [disabled]="computeCanReturn(group)"
                            (click)="createReturn(group)"
                            [pTooltip]="'service.tickets.details.activityDetails.returnToolInfo' | translate">
                    <i class="fa fa-reply" aria-hidden="true"></i>
                </app-button>
            </div>
        </div>
        <div class="tasks">
            <app-task *ngFor="let task of getTasks(group)"
                      [task]="task"
                      [info]="computeStandardTime(task)"
                      [displayCogs]="task.hasSpare"
                      [highlighted]="isTaskHighlighted(task)"
                      [canSelect]="activity && activity.status==='InProgress' && !readonly"
                      [selected]="isTaskSelected(task)"
                      [hasObservations]="task.requiresObservation"
                      (toggleHighlight)="onHighlightTask($event)"
                      (toggleSelect)="onSelectTask($event)">
            </app-task>
        </div>
    </div>
</ng-template>

<app-confirmation-modal #confirmSelection
                        title="{{'service.tickets.details.activityDetails.confirmationModal.title' | translate}}"
                        question="{{'service.tickets.details.activityDetails.confirmationModal.question' | translate}}"
                        message="{{'service.tickets.details.activityDetails.confirmationModal.message' | translate}}"
                        [confirmOnlyMode]="true"
                        (confirmEvent)="onConfirmSelectTask($event)">
</app-confirmation-modal>

<app-confirmation-modal #scanBadge
                        [title]="'service.tickets.details.activityDetails.startOperationModal.title' | translate"
                        [question]="'service.tickets.details.activityDetails.startOperationModal.question'
                          | translate : {name : activity?.name}"
                        [message]="'service.tickets.details.activityDetails.startOperationModal.message' | translate"
                        (scanEvent)="onStartOperation($event)">
</app-confirmation-modal>

<app-confirmation-modal #markTasksDone
                        [title]="'service.tickets.details.activityDetails.markTasksDoneModal.title' | translate"
                        [question]="'service.tickets.details.activityDetails.markTasksDoneModal.question' | translate"
                        [message]="'service.tickets.details.activityDetails.markTasksDoneModal.message' | translate"
                        (scanEvent)="onConfirmMarkTasksDone($event)">
</app-confirmation-modal>

<app-confirmation-modal #markTasksNotDone
                        [title]="'service.tickets.details.activityDetails.markTasksNotDoneModal.title' | translate"
                        [question]="'service.tickets.details.activityDetails.markTasksNotDoneModal.question' | translate"
                        [message]="'service.tickets.details.activityDetails.markTasksNotDoneModal.message' | translate"
                        (scanEvent)="onConfirmMarkTasksNotDone($event)">
</app-confirmation-modal>

<app-confirmation-modal #taskObservation
                        [title]="'service.tickets.details.activityDetails.taskObservationModal.title' | translate"
                        [displayReasonLabel]="'service.tickets.details.activityDetails.taskObservationModal.message' | translate : {name: selectedTasks[0]?.name}"
                        [displayReasonPlaceholder]="'service.tickets.details.activityDetails.taskObservationModal.placeholder' | translate"
                        [confirmWithReason]="true"
                        [reasonMandatory]="true"
                        (confirmEvent)="onSubmitObservation($event)">
</app-confirmation-modal>

<app-confirmation-modal #taskSpareQuantity
                        class="confirmation-modal"
                        [confirmOnlyMode]="true"
                        [title]="'service.tickets.details.activityDetails.taskSpareQuantityModal.title' | translate"
                        [message]="'service.tickets.details.activityDetails.taskSpareQuantityModal.message' | translate : {name: selectedTasks[0]?.name}"
                        [isCustomContent]="true"
                        (confirmEvent)="onSubmitSpareQuantity($event)">
    <app-input modal-custom-content
               [formControl]="form.controls.spareQuantity"
               [showErrors]="showValidations"
               [placeholder]="'service.tickets.details.activityDetails.taskSpareQuantityModal.placeholder' | translate"
               [label]="'service.tickets.details.activityDetails.taskSpareQuantityModal.label' | translate"
               [type]="'number'">
    </app-input>
</app-confirmation-modal>


<app-confirmation-modal #notDoneReason
                        [title]="'service.tickets.details.activityDetails.notDoneModal.title' | translate"
                        [displayReasonLabel]="'service.tickets.details.activityDetails.notDoneModal.message' | translate : {name: selectedTasks[0]?.name}"
                        [displayReasonPlaceholder]="'service.tickets.details.activityDetails.notDoneModal.placeholder' | translate"
                        [confirmWithReason]="true"
                        [reasonMandatory]="true"
                        (confirmEvent)="onReasonMarkTasksAsNotDone($event)">
</app-confirmation-modal>

<app-confirmation-modal #finishGroup
[title]="'service.tickets.details.activityDetails.closeBatchModal.title' | translate"
                        [message]="'service.tickets.details.activityDetails.closeBatchModal.message' | translate"
                        [confirmOnlyMode]="true"
                        [isCustomContent]="true"
                        (confirmEvent)="onConfirmFinishGroup($event)">
    <app-input-switch modal-custom-content
                      [formControl]="form.controls.newTicket"
                      [onLabel]="'generic.yes' | translate"
                      [offLabel]="'generic.no' | translate"
                      [topLabel]="'service.tickets.details.activityDetails.toolWithIssuesFound' | translate">
    </app-input-switch>
</app-confirmation-modal>

<app-ticket-create-modal (create)="onExtractTicket($event)"
                         [config]="tableConfig"
                         [isLoading]="loading">
</app-ticket-create-modal>

<app-confirmation-modal #groupComplete
                        class="confirmation-modal"
                        [confirmOnlyMode]="true"
                        [message]="groupCompletedMessage"
                        [title]="'service.tickets.details.activityDetails.groupComplete' | translate"
                        (confirmEvent)="onConfirmGroupComplete()">
</app-confirmation-modal>

<app-revision-info-modal [title]="'service.tickets.details.activityDetails.revisionInfoModal.title' | translate">
</app-revision-info-modal>

<app-confirmation-modal #scanBadgeForReturn
                        [title]="'service.tickets.details.activityDetails.returnToolsModal.title' | translate"
                        [question]="'service.tickets.details.activityDetails.returnToolsModal.question'| translate"
                        [message]="'service.tickets.details.activityDetails.returnToolsModal.message' | translate"
                        (scanEvent)="onReturnToolsConfirmed($event)">
</app-confirmation-modal>


<app-pdf-viewer>
</app-pdf-viewer>
